// shareDownloadHelpers.js
import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js';

// Canvas.toBlob wrapper (Safari fallback)
function canvasToBlob(canvas, type = 'image/png', quality = 0.95) {
  return new Promise(resolve => {
    if (canvas.toBlob) {
      canvas.toBlob(b => resolve(b), type, quality);
    } else {
      // Fallback via dataURL
      const dataUrl = canvas.toDataURL(type, quality);
      const byteString = atob(dataUrl.split(',')[1]);
      const mimeString = dataUrl
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i += 1)
        ia[i] = byteString.charCodeAt(i);
      resolve(new Blob([ab], { type: mimeString }));
    }
  });
}

export async function elementToPNGBlob(el) {
  // Wait for fonts to be fully loaded before rendering
  if (document.fonts && document.fonts.ready) {
    await document.fonts.ready;
  }
  const canvas = await html2canvas(el, {
    scale: 2, // crisp
    useCORS: true, // images with CORS/ same-origin
    backgroundColor: '#fff',
    logging: false,
  });
  return canvasToBlob(canvas, 'image/png', 0.95);
}

export async function shareElementAsImage(
  el,
  { title = 'Receipt', text = '' } = {}
) {
  const blob = await elementToPNGBlob(el);
  const file = new File([blob], 'receipt.png', { type: 'image/png' });

  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    await navigator.share({ files: [file], title, text });
    return true;
  }

  // Fallback for browsers that only share link/text (no files)
  if (navigator.share) {
    try {
      await navigator.share({ title, text, url: window.location.href });
      return true;
    } catch (e) {
      // ignore AbortError
    }
  }
  return false; // signal caller to fallback (e.g., print)
}

export async function downloadElementAsPDF(
  el,
  { fileName = 'receipt.pdf' } = {}
) {
  // Wait for fonts to be fully loaded before rendering
  if (document.fonts && document.fonts.ready) {
    await document.fonts.ready;
  }
  const opts = {
    margin: 30, // pt
    filename: fileName,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true, backgroundColor: '#fff' },
    jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' },
    pagebreak: { mode: ['css', 'legacy'] },
  };
  await html2pdf()
    .set(opts)
    .from(el)
    .save();
}
